import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getInvitedTalentApi , searchCandidatesAPI } from '../../API/API'

function* invitedCandidateSaga(params) {
    try {
        const response = yield call(() => getInvitedTalentApi(params.payload)); 
        yield put({type: types.FETCH_INVITED_CANDIDATES_SUCCESS, payload: response.data});
      }
      catch (error) {
        yield put({type: types.FETCH_INVITED_CANDIDATES_FAILURE, error});
    }
}

export function* watchinvitedCandidateSaga() {
    yield takeEvery(types.FETCH_INVITED_CANDIDATES, invitedCandidateSaga);
}